import ivclass from '@invideoio/web-shared/Modules/IVClass';

import SearchBox from '@components/search-box';

import { HeroSectionHeadingType } from '../../types';
import { HeadingStyleType } from '../../constants/common';
import useTranslation from 'next-translate/useTranslation';

interface HomePageSearchProps {
  headingGroup: HeroSectionHeadingType;
}

const HomePageSearch = (props: HomePageSearchProps) => {
  const { heading1, heading2, heading1Style, heading2Style } =
    props.headingGroup;

  const { t } = useTranslation('common');
  return (
    <section
      className={ivclass(
        'iv-container iv-mx-auto',
        'iv-mt-[87px] lg:iv-mt-[87px] md:iv-mt-[69px] sm:iv-mt-[43px]',
        'iv-mb-100 lg:iv-mb-100 md:iv-mb-80 sm:iv-mb-50',
      )}
    >
      <div className={ivclass('iv-grid iv-grid-cols-12 iv-col-span-12')}>
        <div
          className={ivclass(
            'iv-col-start-2 lg:iv-col-start-2  sm:iv-col-start-1',
            'iv-col-span-10 sm:iv-col-span-12',
            'sm:iv-px-25',
            'sm:iv-leading-[49px]',
            'md:iv-text-center sm:iv-text-center',
          )}
        >
          <h1
            className={ivclass(
              'iv-text-heading-4xl md:iv-text-heading-3xl sm:iv-text-heading-m ',
              'md:iv-leading-[80px]',
              'iv-px-30 lg:iv-px-[0] sm:iv-px-[0] sm:iv-pl-[4px]',
              'iv-mx-[-13px]',
              'iv-font-extrabold md:iv-font-extrabold sm:iv-font-extrabold',
              'iv-mb-[61px] xl:iv-mb-[61px] md:iv-mb-[39px] sm:iv-mb-[20px]',
            )}
          >
            <span
              className={ivclass(
                'iv-block',
                heading1Style === HeadingStyleType.Highlighted &&
                  'iv-heading-gradient ',
              )}
            >
              {heading1}
            </span>
            <span
              className={ivclass(
                heading2Style === HeadingStyleType.Highlighted &&
                  'iv-heading-gradient ',
              )}
            >
              {heading2}
            </span>
          </h1>
          <div className={ivclass('iv-grid iv-grid-cols-12')}>
            <div
              className={ivclass(
                'xl:iv-col-span-7 lg:iv-col-span-7 iv-col-span-12',
              )}
            >
              <div
                className={ivclass(
                  'iv-pl-20 lg:iv-pl-[0] md:iv-pl-5 sm:iv-pl-[0]',
                  'lg:iv-mx-[-5px]',
                  'md:iv-pr-10',
                )}
              >
                <SearchBox placeholder={t('Search Placeholder')} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomePageSearch;
